import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";

import Container from "../components/container/container.component";
import Button from "../components/buttons/button.component";
import FormInput from "../components/inputs/form.input.component";
import { URLDevelopment } from "../helpers/URL";

const VerifyOtp = () => {
  const history = useHistory();
  const location = useLocation();

  const email = location.state?.email;

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // ❌ Prevent direct access
  if (!email) {
    history.replace("/register");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp || otp.length !== 6) {
      return toast.error("Enter valid 6-digit OTP");
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${URLDevelopment}/api/user/verify-otp`,
        {
          email,
          otp: otp.trim(),
        }
      );

      toast.success(res.data.message || "OTP verified");

      history.replace("/login");

    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Invalid or expired OTP";

      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl shadow-2xl p-6 my-20 max-w-md mx-auto flex flex-col space-y-5"
      >
        <h2 className="text-2xl font-bold text-center">
          Verify OTP
        </h2>

        <p className="text-sm text-center text-gray-600">
          OTP sent to <br />
          <span className="font-semibold">{email}</span>
        </p>

        <FormInput
          title="Enter OTP"
          placeholder="123456"
          value={otp}
          handleChange={(e) =>
            setOtp(e.target.value.replace(/\D/g, ""))
          }
          type="text"
        />

        <Button
          title={loading ? "Verifying..." : "Verify OTP"}
          type="submit"
          moreStyle="w-full py-3 text-lg"
        />
      </form>
    </Container>
  );
};

export default VerifyOtp;